/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_Dimmer_DimmerEffectSchedulerEffectsModel } from '../models/BigClock_Api_Models_Dimmer_DimmerEffectSchedulerEffectsModel';
import type { BigClock_Api_Models_Dimmer_RunDimmerEffect } from '../models/BigClock_Api_Models_Dimmer_RunDimmerEffect';
import type { BigClock_Api_Models_Dimmer_SchedulerStateModel } from '../models/BigClock_Api_Models_Dimmer_SchedulerStateModel';
import type { BigClock_Api_Models_Dimmer_SetDimmerChannelsStateModel } from '../models/BigClock_Api_Models_Dimmer_SetDimmerChannelsStateModel';
import type { BigClock_Api_Models_Dimmer_SetDimmerEffectsDelayModel } from '../models/BigClock_Api_Models_Dimmer_SetDimmerEffectsDelayModel';
import type { BigClock_Api_Models_Dimmer_SetDimmerFadeModel } from '../models/BigClock_Api_Models_Dimmer_SetDimmerFadeModel';
import type { BigClock_Api_Models_Dimmer_SetDimmerRelayModel } from '../models/BigClock_Api_Models_Dimmer_SetDimmerRelayModel';
import type { BigClock_Api_Models_OnOffTimeModel } from '../models/BigClock_Api_Models_OnOffTimeModel';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Queries_GetDimmerCoordinates_GetDimmerCoordinatesResponse } from '../models/BigClock_Application_Queries_GetDimmerCoordinates_GetDimmerCoordinatesResponse';
import type { BigClock_Application_Queries_GetDimmerData_GetDimmerDataResponse } from '../models/BigClock_Application_Queries_GetDimmerData_GetDimmerDataResponse';
import type { BigClock_Application_Queries_GetDimmerSchedulerOnOffTime_GetDimmerSchedulerOnOffTimeResponse } from '../models/BigClock_Application_Queries_GetDimmerSchedulerOnOffTime_GetDimmerSchedulerOnOffTimeResponse';
import type { BigClock_Application_Queries_ReadDimmerParams_ReadDimmerParamsResponse } from '../models/BigClock_Application_Queries_ReadDimmerParams_ReadDimmerParamsResponse';
import type { BigClock_Domain_DimmerDetails } from '../models/BigClock_Domain_DimmerDetails';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DimmerService {
    /**
     * @param dimmerId
     * @returns BigClock_Application_Queries_GetDimmerData_GetDimmerDataResponse Success
     * @throws ApiError
     */
    public static getApiDimmer(
        dimmerId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDimmerData_GetDimmerDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiDimmer(
        dimmerId: string,
        requestBody?: BigClock_Domain_DimmerDetails,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Dimmer/{dimmerId}',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @returns BigClock_Application_Queries_ReadDimmerParams_ReadDimmerParamsResponse Success
     * @throws ApiError
     */
    public static getApiDimmerParams(
        dimmerId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadDimmerParams_ReadDimmerParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}/params',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @returns BigClock_Application_Queries_GetDimmerCoordinates_GetDimmerCoordinatesResponse Success
     * @throws ApiError
     */
    public static getApiDimmerGpsCoordinates(
        dimmerId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDimmerCoordinates_GetDimmerCoordinatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}/gps/coordinates',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerLightState(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/light/state',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerRelayState(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/relay/state',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerRelayMode(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_SetDimmerRelayModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/relay/mode',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerChannelsFade(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_SetDimmerFadeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/channels/fade',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerChannelsState(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_SetDimmerChannelsStateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/channels/state',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerCircularEffects(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/circular-effects',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerEffectsRunClock(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_RunDimmerEffect,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/effects/run-clock',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerEffectsRunAll(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_RunDimmerEffect,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/effects/run-all',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerEffectsRunAlways(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/effects/run-always',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerEffectsDelay(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_SetDimmerEffectsDelayModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/effects/delay',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerSchedulerMode(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_SchedulerStateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/scheduler/mode',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @returns BigClock_Api_Models_OnOffTimeModel Success
     * @throws ApiError
     */
    public static getApiDimmerSchedulerTimeDuskDawn(
        dimmerId: string,
    ): CancelablePromise<BigClock_Api_Models_OnOffTimeModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}/scheduler/time/dusk-dawn',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @returns BigClock_Application_Queries_GetDimmerSchedulerOnOffTime_GetDimmerSchedulerOnOffTimeResponse Success
     * @throws ApiError
     */
    public static getApiDimmerSchedulerTime(
        dimmerId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDimmerSchedulerOnOffTime_GetDimmerSchedulerOnOffTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}/scheduler/time',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerSchedulerTime(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_OnOffTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/scheduler/time',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param dimmerId
     * @returns BigClock_Api_Models_Dimmer_DimmerEffectSchedulerEffectsModel Success
     * @throws ApiError
     */
    public static getApiDimmerSchedulerEffects(
        dimmerId: string,
    ): CancelablePromise<Array<BigClock_Api_Models_Dimmer_DimmerEffectSchedulerEffectsModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Dimmer/{dimmerId}/scheduler/effects',
            path: {
                'dimmerId': dimmerId,
            },
        });
    }
    /**
     * @param dimmerId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDimmerSchedulerEffects(
        dimmerId: string,
        requestBody?: BigClock_Api_Models_Dimmer_DimmerEffectSchedulerEffectsModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Dimmer/{dimmerId}/scheduler/effects',
            path: {
                'dimmerId': dimmerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
